import React, { forwardRef } from 'react';

import clsx from 'classnames';

export const Link = forwardRef(function Link(
  {
    children,
    className,
    display = 'span',
    inheritColor,
    inheritFontSize,
    inheritFontWeight,
    size,
    ...props
  },
  ref
) {
  const linkClasses = clsx(
    {
      'cdl-link': true,
      'cdl-link--inherit-color': inheritColor,
      'cdl-link--inherit-font-size': inheritFontSize,
      'cdl-link--inherit-font-weight': inheritFontWeight,

      'cdl-link--small': size === 'small',
      'cdl-link--large': size === 'large',

      'cdl-link--block': display === 'block',
      'cdl-link--inline-block': display === 'inline-block',
      'cdl-link--span': display === 'span',
      'cdl-link--flex': display === 'flex',
      'cdl-link--inline-flex': display === 'inline-flex',
    },
    className
  );

  return (
    <a ref={ref} className={linkClasses} href="test" {...props}>
      {children}
    </a>
  );
});
